import * as React from "react";
import { BooleanInput } from "../../atoms/forms/BooleanInput";
import { ICommonInputsControlsWithLabel } from "../../atoms/forms/ICommonInputsControls";
import { useTranslation } from 'react-i18next';

// All the incoming values
interface IProps {
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & ICommonInputsControlsWithLabel<boolean>;

export const AppointmentRequiredInput = (props: AllProps) => {
    const { t } = useTranslation('common');
    
    return (
        <BooleanInput
            {...props}
            trueLabel={t('yes')}
            falseLabel={t('no')}
        />
    );
}
